import React, { memo, useContext, useEffect, useMemo } from "react";
import Helmet from "react-helmet";

import { Search, useSearch } from "@usereactify/search";
import { ResultStatsContext, ResultStatsProvider } from "../../context/ResultStatsContext";
import { ViewSettingsProvider } from "../../context/ViewSettingsContext";
import { Filters } from "../Filters/Filters";
import { SearchForm } from "../Form/SearchForm";
import { Results } from "../Results/Results";
import { ShowingResults } from "../ResultsMeta/ShowingResults";

export const SearchComp: React.FC<any> = (props) => {
  const { setSearchTerm } = useSearch();
  const clearSearchQuery = () => {
    setSearchTerm("");
    const searchForm = document.querySelector<HTMLInputElement>("#reactify-mount-search .reactify-search-input");
    if (searchForm) searchForm.focus();
  };

  return (
    <>
      <Search render={SearchForm} />
      <div>
        <ViewSettingsProvider>
          <ResultStatsProvider>
            <Meta />
            <SearchResultsCount />
            <ShowingResults resultsMetaClasses="h3 search-showing" />
            <div className="product-list">
              <div className="medium-up--one-whole grid__item--sidebar">
                <div id="CollectionSidebar">
                  <div className="collection-sidebar small--hide" id="CollectionSidebarFilterWrap">
                    <Filters mobile={false} />
                  </div>
                </div>
              </div>

              <div className="collection-filter__item collection-filter__item--left medium-up--hide">
                <Filters mobile={true} />
              </div>

              <Results colorGroups={props.colorGroups} pageSize={40} />
            </div>
          </ResultStatsProvider>
        </ViewSettingsProvider>
      </div>
    </>
  );
};

const SearchResultsCount = () => {
  const { searchTerm } = useSearch();
  const { numberOfResults } = useContext(ResultStatsContext);

  useEffect(() => {
    const element = document.getElementById("search-results-count");
    if (element) {
      element.textContent = `${numberOfResults || 0} ${
        numberOfResults === 1 ? "result" : "results"
      } for "${searchTerm}"`;
    }
  }, [numberOfResults, searchTerm]);

  return null;
};

const Meta: React.FC = memo(() => {
  const { searchTerm } = useSearch();
  const { numberOfResults, displayedResults } = useContext(ResultStatsContext);

  const title = useMemo(() => {
    return !displayedResults
      ? `Search: No results found for "${searchTerm}"`
      : `Search: ${displayedResults} of ${numberOfResults} results found for "${searchTerm}"`;
  }, [displayedResults, numberOfResults, searchTerm]);

  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
});
